<div class="left-sidebar" [ngClass]="{ mini: menu.isMini }">
  <div class="logo-cnt">
    <div class="logo-cnt-inner"></div>
  </div>

  <div class="left-menu-cnt">
    <ng-scrollbar>
      <!-- Admin Menu start -->
      <ul>
        @if(showDahsboard){
          <li>
            <div class="inner-li" [routerLink]="['/main/dashboard']" routerLinkActive="active"
              [tooltip]="menu.isMini ? 'Dashboard' : ''" placement="right" container="body" >
              <i class="fa fa-tachometer"></i><span>Dashboard</span>
            </div>
          </li>
        }
        
        @for (menu_item of accessibleMenu; track menu_item; let i = $index) {
          @if(!menu_item['isHidden']){
            <li>
              @if (!menu_item['submenu']?.length) {
                <a
                  (click)="subMenuToggle(i)"
                  class="inner-li"
                  [routerLink]="[menu_item['parentRoute']]"
                  routerLinkActive="active"
                  [tooltip]="menu.isMini ? menu_item['menuName'] : ''"
                  placement="right"
                  container="body">
                  <i [class]="menu_item['class']"></i>
                  <span>{{ menu_item['menuName'] }}</span>
                </a>
              } @else {
                <a
                  class="inner-li sub-menu-outer d-flex align-items-center"
                  (click)="subMenuToggle(i)"
                  routerLinkActive="active"
                  [tooltip]="menu.isMini ? menu_item['menuName'] : ''"
                  placement="right"
                  container="body">
                  <i [class]="menu_item['class']"></i>
                  <span class="ms-0">{{ menu_item['menuName'] }}</span>
                  <i
                      class="fa ms-auto me-0"
                      [ngClass]="{
                        'fa-angle-right': !menu_item.menu,
                        'fa-angle-down': menu_item.menu 
                      }"
                    ></i>
                </a>
                <ul class="sub-menu" [ngClass]="{ 'show-menu': menu_item.menu }">
                @for (item of menu_item['submenu']; track item) {
                  @if(!item['isHidden']){
                    <li>
                      <a
                        class="inner-li"
                        [ngClass]="{ 'show-menu': item.menu }"
                        [routerLink]="[item.route]"
                        routerLinkActive="active"
                        [tooltip]="menu.isMini ? item.menuName : ''"
                        placement="right"
                        container="body">
                        <i [class]="item.class"></i>
                        <span>{{ item.menuName }}</span>
                      </a>
                    </li>
                  }
                }
              </ul>
              }

              
            </li>
          }
        }
          
      </ul>
      <!-- Admin Menu end -->
    </ng-scrollbar>
  </div>
</div>